import React from 'react';

import {salon} from '../config/salon';

export const QuickContact: React.FC = () => {
  return (
    <a
      className='quick-contact'
      href={salon.whatsappHref}
      target='_blank'
      rel='noreferrer'
      aria-label='WhatsApp ile hızlı iletişim'
    >
      Hızlı İletişim
    </a>
  );
};
